import React from 'react'
import { TypeAttributes } from 'rsuite/esm/internals/types'
import { ReactComponent as Info } from '../../../assets/svgs/Info.svg'
import { Tooltip, Whisper } from 'rsuite'
import './info-tooltip.scss'

export type TooltipPlacement = TypeAttributes.Placement

interface ToolTopProps {
  styleClass?: string
  tooltipContent: string | React.ReactNode
  children?: React.ReactNode
  placement?: TooltipPlacement
  followCursor?: boolean
  delay?: number
}

export const InfoTooltip: React.FC<ToolTopProps> = ({
  styleClass = '',
  tooltipContent,
  children,
  placement,
  followCursor = false,
  delay,
}) => {
  const tooltip = <Tooltip>{tooltipContent}</Tooltip>

  return (
    <div className={`tooltip ${styleClass}`}>
      <Whisper
        trigger={'hover'}
        placement={placement || 'auto'}
        speaker={tooltip}
        followCursor={followCursor}
        delay={delay}
      >
        {children ? children : <Info className="info-icon-color" />}
      </Whisper>
    </div>
  )
}
